<lib-header title="Notifications" leftActionButton="back-button" backButtonDefaultHref="/" [centerTitle]="true" />
<ion-content>
    <lib-loading-state *ngIf="!loaded"></lib-loading-state>

    <div *ngIf="notifications.length === 0 && loaded">
        <p class="ion-text-center ion-padding-vertical">No new notifications</p>
    </div>

    <div class="ion-padding-vertical" *ngIf="notifications.length > 0 && loaded">
        @for (n of notifications; track n.id; let index = $index) {
            <ion-item
                lines="none"
                class="ion-wrap ion-no-padding"
                [ngClass]="{ 'border-top': index > 0 }"
                [button]="true"
                (click)="clickNotification(n)">
                <div slot="start" class="ion-align-self-start ion-padding-vertical ion-padding-start">
                    <!-- Add icons here -->
                </div>

                <div class="ion-align-self-start ion-padding-vertical">
                    <p class="text-dark ion-no-margin">{{ n.notification }}</p>
                    <p class="ion-no-margin text-midsmall">{{ n.created_at | date: 'h:mm aa, d MMM yyyy' }}</p>
                </div>

                <div slot="end" class="ion-align-self-start ion-padding-vertical">
                    <lib-close-button (onClick)="removeNotification(n.id)" />
                </div>
            </ion-item>
        }
    </div>
</ion-content>
